<app-spinner-service></app-spinner-service>
<p-toolbar>
    <div class="p-toolbar-group-left">
    </div>
    <div class="p-toolbar-group-right">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="applyFilterGlobal($any($event.target).value)" placeholder="Pesquisar" />
        </span>
    </div>
</p-toolbar>

<p-tabView [(activeIndex)]="abaAtiva">
    <p-tabPanel *ngFor="let grupo of gruposTributos; let i = index" [header]="grupo.titulo">
        <div class="mb-4 w-1/4">
            <label for="filtroStatusPagamento" class="block mb-1 font-semibold">Filtrar status pagamento</label>
            <p-dropdown inputId="filtroStatusPagamento" [options]="tiposConfirmacaoPagamento" optionLabel="label"
                optionValue="value" [(ngModel)]="filtroTipoSelecionado" (onChange)="filtrarPorTipo()"
                placeholder="Selecione" [appendTo]="'body'" styleClass="w-full">
            </p-dropdown>
        </div>
        <div class="mb-2">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="applyFilterAba($event, i)" placeholder="Pesquisar nesta aba" />
            </span>
        </div>
        <p-table #dtTable [value]="grupo.tributos" [scrollable]="true" scrollHeight="500px"
            [globalFilterFields]="globalFilters" [customSort]="true" [loading]="loading"
            (sortFunction)="customSort($event)" styleClass="custom-table">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="imposto">Imposto <p-sortIcon field="imposto"></p-sortIcon>
                    </th>
                    <th pSortableColumn="competencia">Competência <p-sortIcon
                            field="competencia"></p-sortIcon></th>
                    <th pSortableColumn="vencimento">Vencimento <p-sortIcon
                            field="vencimento"></p-sortIcon></th>
                    <th pSortableColumn="valor">Valor <p-sortIcon field="valor"></p-sortIcon></th>
                    <th>Status pagamento</th>
                    <th>Baixar</th>
                </tr>
            </ng-template>
            <ng-container *ngIf="grupo.tributos.length > 0">
                <ng-template pTemplate="body" let-tributoLinha>
                    <tr [ngClass]="{'linha-verde': tributoLinha.confirmacaoPagamento === 1}">
                        <td>
                            <div class="imposto-content">
                                <i class="pi pi-file-pdf imposto-icon"></i>
                                <span class="imposto-text" [pTooltip]="tributoLinha?.imposto" tooltipPosition="top">{{ tributoLinha?.imposto }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="competencia-content">
                                <i class="pi pi-calendar competencia-icon"></i>
                                <span class="competencia-text" [pTooltip]="tributoLinha?.competencia" tooltipPosition="top">{{ tributoLinha?.competencia }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="vencimento-content">
                                <i class="pi pi-clock vencimento-icon"></i>
                                <span class="vencimento-text" [pTooltip]="formatarDataExibicao(tributoLinha?.vencimento)" tooltipPosition="top">{{ formatarDataExibicao(tributoLinha?.vencimento) }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="valor-content">
                                <i class="pi pi-dollar valor-icon"></i>
                                <span class="valor-text" [pTooltip]="formatarValor(tributoLinha?.valor)" tooltipPosition="top">{{ formatarValor(tributoLinha?.valor) }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="status-pagamento">
                                <button pButton pRipple icon="pi pi-check"
                                    [pTooltip]="tributoLinha.confirmacaoPagamento === 0 ? 'Confirmar pagamento' : 'Cancelar confirmação de pagamento'"
                                    tooltipPosition="left" class="mr-2 p-button-rounded" [loading]="carregando" [ngClass]="{
                      'p-button-info': tributoLinha.confirmacaoPagamento === 0,
                      'p-button-success': tributoLinha.confirmacaoPagamento === 1
                    }" (click)="confirmarPagamento(tributoLinha)">
                                </button>
                                <span [ngClass]="{'pago': tributoLinha.confirmacaoPagamento === 1}">{{
                                    tributoLinha.confirmacaoPagamento === 0 ? 'A pagar' : 'Pago' }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="download-content">
                                <button pButton pRipple icon="pi pi-download" tooltipPosition="left"
                                    class="mr-2 p-button" (click)="baixarArquivo(tributoLinha)"
                                    [disabled]="!tributoLinha?.id"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </ng-container>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-center">Nenhum imposto encontrado</td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
</p-tabView>